/** Кик-офф: в БД UTC (naive date+time), на экране — стенное время пояса площадки. */

export const DEFAULT_MATCH_TZ = 'Europe/Moscow';

const pad2 = (value) => String(value).padStart(2, '0');

/** Пояс хранения кик-оффа (UTC), не пояса площадки — пропускаем при выборе venue TZ. */
const isStorageTimezone = (tz) => /^(utc|gmt|etc\/utc|etc\/gmt([+-]\d+)?|z)$/i.test(String(tz || '').trim());

/**
 * Fallback по name / name_ru из таблицы cities, пока API не всегда отдаёт IANA.
 * Ключи после normalizeCityKey (lowercase, ё→е, пунктуация → пробел).
 */
const CITY_TIMEZONE_BY_NAME = {
  // —— Europe/Moscow (UTC+3) ——
  moscow: 'Europe/Moscow',
  москва: 'Europe/Moscow',
  'st petersburg': 'Europe/Moscow',
  'санкт петербург': 'Europe/Moscow',
  петербург: 'Europe/Moscow',
  spb: 'Europe/Moscow',
  'rostov on don': 'Europe/Moscow',
  'ростов на дону': 'Europe/Moscow',
  ростов: 'Europe/Moscow',
  'yoshkar ola': 'Europe/Moscow',
  'йошкар ола': 'Europe/Moscow',
  sochi: 'Europe/Moscow',
  сочи: 'Europe/Moscow',
  saransk: 'Europe/Moscow',
  саранск: 'Europe/Moscow',
  anapa: 'Europe/Moscow',
  анапа: 'Europe/Moscow',
  armavir: 'Europe/Moscow',
  армавир: 'Europe/Moscow',
  kazan: 'Europe/Moscow',
  казань: 'Europe/Moscow',
  zelenograd: 'Europe/Moscow',
  зеленоград: 'Europe/Moscow',
  khimki: 'Europe/Moscow',
  химки: 'Europe/Moscow',
  balashikha: 'Europe/Moscow',
  балашиха: 'Europe/Moscow',
  petrozavodsk: 'Europe/Moscow',
  петрозаводск: 'Europe/Moscow',
  'penza region': 'Europe/Moscow',
  'пензенская область': 'Europe/Moscow',
  пенза: 'Europe/Moscow',
  arkhangelsk: 'Europe/Moscow',
  архангельск: 'Europe/Moscow',
  elista: 'Europe/Moscow',
  элиста: 'Europe/Moscow',
  'world cup': 'Europe/Moscow',
  'чемпионат мира': 'Europe/Moscow',
  tula: 'Europe/Moscow',
  тула: 'Europe/Moscow',
  maykop: 'Europe/Moscow',
  майкоп: 'Europe/Moscow',
  krasnodar: 'Europe/Moscow',
  краснодар: 'Europe/Moscow',
  ryazan: 'Europe/Moscow',
  рязань: 'Europe/Moscow',
  lipetsk: 'Europe/Moscow',
  липецк: 'Europe/Moscow',
  ivanovo: 'Europe/Moscow',
  иваново: 'Europe/Moscow',
  vladimir: 'Europe/Moscow',
  владимир: 'Europe/Moscow',
  pyatigorsk: 'Europe/Moscow',
  пятигорск: 'Europe/Moscow',
  vladikavkaz: 'Europe/Moscow',
  владикавказ: 'Europe/Moscow',
  borisoglebsk: 'Europe/Moscow',
  борисоглебск: 'Europe/Moscow',
  'moscow region': 'Europe/Moscow',
  'московская область': 'Europe/Moscow',
  bryansk: 'Europe/Moscow',
  брянск: 'Europe/Moscow',
  kaluga: 'Europe/Moscow',
  калуга: 'Europe/Moscow',
  'barca cup': 'Europe/Moscow',
  'кубок барса': 'Europe/Moscow',
  'кубок будущих легенд': 'Europe/Moscow',
  sevastopol: 'Europe/Simferopol',
  севастополь: 'Europe/Simferopol',
  odintsovo: 'Europe/Moscow',
  одинцово: 'Europe/Moscow',
  makhachkala: 'Europe/Moscow',
  махачкала: 'Europe/Moscow',
  'nizhniy novgorod': 'Europe/Moscow',
  'nizhny novgorod': 'Europe/Moscow',
  'нижний новгород': 'Europe/Moscow',
  salsk: 'Europe/Moscow',
  салск: 'Europe/Moscow',
  zheleznodorozhniy: 'Europe/Moscow',
  железнодорожный: 'Europe/Moscow',
  naltchik: 'Europe/Moscow',
  нальчик: 'Europe/Moscow',
  torzhok: 'Europe/Moscow',
  торжок: 'Europe/Moscow',
  oryol: 'Europe/Moscow',
  orel: 'Europe/Moscow',
  орел: 'Europe/Moscow',
  орёл: 'Europe/Moscow',
  kirov: 'Europe/Kirov',
  киров: 'Europe/Kirov',
  'naberezhnye chelny': 'Europe/Moscow',
  'набережные челны': 'Europe/Moscow',
  калининград: 'Europe/Kaliningrad',
  kaliningrad: 'Europe/Kaliningrad',

  // —— Europe/Samara / Volga UTC+4 ——
  samara: 'Europe/Samara',
  самара: 'Europe/Samara',
  tolyatti: 'Europe/Samara',
  togliatti: 'Europe/Samara',
  тольятти: 'Europe/Samara',
  syzran: 'Europe/Samara',
  сызрань: 'Europe/Samara',
  ulyanovsk: 'Europe/Ulyanovsk',
  ульяновск: 'Europe/Ulyanovsk',
  izhevsk: 'Europe/Samara',
  ижевск: 'Europe/Samara',
  astrakhan: 'Europe/Astrakhan',
  астрахань: 'Europe/Astrakhan',
  saratov: 'Europe/Saratov',
  саратов: 'Europe/Saratov',
  engels: 'Europe/Saratov',
  энгельс: 'Europe/Saratov',
  marks: 'Europe/Saratov',
  маркс: 'Europe/Saratov',
  balakovo: 'Europe/Saratov',
  балаково: 'Europe/Saratov',
  volsk: 'Europe/Saratov',
  вольск: 'Europe/Saratov',
  'khvalinskiy region': 'Europe/Saratov',
  'хвалынский район': 'Europe/Saratov',

  // —— Asia/Yekaterinburg (UTC+5) ——
  ekaterinburg: 'Asia/Yekaterinburg',
  yekaterinburg: 'Asia/Yekaterinburg',
  екатеринбург: 'Asia/Yekaterinburg',
  'nizhny tagil': 'Asia/Yekaterinburg',
  'нижний тагил': 'Asia/Yekaterinburg',
  perm: 'Asia/Yekaterinburg',
  пермь: 'Asia/Yekaterinburg',
  tyumen: 'Asia/Yekaterinburg',
  тюмень: 'Asia/Yekaterinburg',
  neftekamsk: 'Asia/Yekaterinburg',
  нефтекамск: 'Asia/Yekaterinburg',
  chelyabinsk: 'Asia/Yekaterinburg',
  челябинск: 'Asia/Yekaterinburg',
  уфа: 'Asia/Yekaterinburg',
  ufa: 'Asia/Yekaterinburg',

  // —— Siberia / Far East ——
  omsk: 'Asia/Omsk',
  омск: 'Asia/Omsk',
  novosibirsk: 'Asia/Novosibirsk',
  новосибирск: 'Asia/Novosibirsk',
  novokuznetsk: 'Asia/Novokuznetsk',
  новокузнецк: 'Asia/Novokuznetsk',
  kemerovo: 'Asia/Novokuznetsk',
  кемерово: 'Asia/Novokuznetsk',
  tomsk: 'Asia/Tomsk',
  томск: 'Asia/Tomsk',
  barnaul: 'Asia/Barnaul',
  барнаул: 'Asia/Barnaul',
  krasnoyarsk: 'Asia/Krasnoyarsk',
  красноярск: 'Asia/Krasnoyarsk',
  norilsk: 'Asia/Krasnoyarsk',
  норильск: 'Asia/Krasnoyarsk',
  irkutsk: 'Asia/Irkutsk',
  иркутск: 'Asia/Irkutsk',
  chita: 'Asia/Chita',
  чита: 'Asia/Chita',
  yakutsk: 'Asia/Yakutsk',
  якутск: 'Asia/Yakutsk',
  vladivostok: 'Asia/Vladivostok',
  владивосток: 'Asia/Vladivostok',
  хабаровск: 'Asia/Vladivostok',
  khabarovsk: 'Asia/Vladivostok',
  magadan: 'Asia/Magadan',
  магадан: 'Asia/Magadan',
  kamchatka: 'Asia/Kamchatka',
  камчатка: 'Asia/Kamchatka',
  петропавловск: 'Asia/Kamchatka',

  // —— CIS / abroad ——
  kyiv: 'Europe/Kyiv',
  kiev: 'Europe/Kyiv',
  киев: 'Europe/Kyiv',
  odessa: 'Europe/Kyiv',
  odesa: 'Europe/Kyiv',
  одесса: 'Europe/Kyiv',
  sumy: 'Europe/Kyiv',
  сумы: 'Europe/Kyiv',
  lutsk: 'Europe/Kyiv',
  луцк: 'Europe/Kyiv',
  almaty: 'Asia/Almaty',
  алматы: 'Asia/Almaty',
  pavlodar: 'Asia/Almaty',
  павлодар: 'Asia/Almaty',
  minsk: 'Europe/Minsk',
  минск: 'Europe/Minsk',
  pinsk: 'Europe/Minsk',
  пинск: 'Europe/Minsk',
  yerevan: 'Asia/Yerevan',
  ереван: 'Asia/Yerevan',
  praha: 'Europe/Prague',
  prague: 'Europe/Prague',
  прага: 'Europe/Prague',
  warshawa: 'Europe/Warsaw',
  warsaw: 'Europe/Warsaw',
  варшава: 'Europe/Warsaw',
  kishinev: 'Europe/Chisinau',
  chisinau: 'Europe/Chisinau',
  кишинев: 'Europe/Chisinau',
  кишинёв: 'Europe/Chisinau',
  tashkent: 'Asia/Tashkent',
  ташкент: 'Asia/Tashkent',
  jizzax: 'Asia/Tashkent',
  джизак: 'Asia/Tashkent',
  fergana: 'Asia/Tashkent',
  фергона: 'Asia/Tashkent',
  thailand: 'Asia/Bangkok',
  таиланд: 'Asia/Bangkok',
  bangkok: 'Asia/Bangkok',
  istanbul: 'Europe/Istanbul',
  стамбул: 'Europe/Istanbul',
};

const normalizeCityKey = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/ё/g, 'е')
  .replace(/[^a-zа-я0-9]+/gi, ' ')
  .trim();

export const timezoneFromCityName = (value) => {
  const key = normalizeCityKey(value);
  if (!key) return '';
  if (CITY_TIMEZONE_BY_NAME[key]) return CITY_TIMEZONE_BY_NAME[key];

  const cities = Object.keys(CITY_TIMEZONE_BY_NAME).sort((a, b) => b.length - a.length);

  // Многословные: «нижний новгород», «rostov on don», «г новокузнецк afl»
  const phraseHit = cities.find((city) => {
    if (!city.includes(' ')) return false;
    return key === city || key.includes(city);
  });
  if (phraseHit) return CITY_TIMEZONE_BY_NAME[phraseHit];

  const tokens = key.split(/\s+/);
  const hit = cities.find((city) => {
    if (city.includes(' ')) return false;
    return tokens.some((token) => (
      token === city || (city.length >= 4 && token.startsWith(city))
    ));
  });
  return hit ? CITY_TIMEZONE_BY_NAME[hit] : '';
};

const cityNameCandidates = (source) => {
  if (!source || typeof source !== 'object') return [];
  const cityObj = source.city && typeof source.city === 'object' ? source.city : null;
  return [
    typeof source.city === 'string' ? source.city : '',
    source.city_ru,
    source.city_name,
    source.cityName,
    source.town,
    source.region,
    // В дереве админки «country» часто = город площадки (Новосибирск), не «Россия»
    source.country?.name,
    source.country_name,
    source.country?.city,
    source.country?.city_ru,
    source.name && (source.city_id || source.city_ru || source.flag) ? source.name : '',
    cityObj?.name,
    cityObj?.city,
    cityObj?.city_ru,
    cityObj?.title,
    source.stadium?.city,
    source.stadium?.city_ru,
    source.stadium?.city_name,
    source.stadium?.name,
    source.league?.city,
    source.league?.city_ru,
    source.league?.city_name,
    source.league?.name,
    source.league_name,
    source.championship?.city,
    source.championship?.city_ru,
    source.championship?.name,
    source.tournament?.city,
    source.tournament?.city_ru,
    source.tournament?.name,
    source.tournament_name,
  ].filter(Boolean);
};

const explicitTimezoneCandidates = (source) => {
  if (!source || typeof source !== 'object') return [];
  const settings = source.settings && typeof source.settings === 'object' ? source.settings : {};
  // venue_timezone — пояс площадки; timezone на карточке матча часто "UTC" (хранение) и отсекается.
  return [
    source.venue_timezone,
    source.venueTimezone,
    source.venue_tz,
    settings.venue_timezone,
    settings.timezone,
    settings.time_zone,
    source.timezone,
    source.time_zone,
    source.tz,
    source.stadium?.venue_timezone,
    source.stadium?.timezone,
    source.stadium?.time_zone,
    source.city?.venue_timezone,
    source.city?.timezone,
    source.city?.time_zone,
    source.city_timezone,
    source.league?.venue_timezone,
    source.league?.timezone,
    source.league?.time_zone,
    source.championship?.venue_timezone,
    source.championship?.timezone,
    source.championship?.time_zone,
    source.tournament?.venue_timezone,
    source.tournament?.timezone,
    source.tournament?.time_zone,
    source.country?.venue_timezone,
    source.country?.timezone,
    source.country?.time_zone,
  ];
};

export const kickoffClock = (time) => {
  const value = String(time || '').trim();
  if (!value || value === '—') return '';
  // "10:30:00.000Z" / "10:30:00Z"
  const cleaned = value.replace(/\.?\d*Z$/i, '').replace(/Z$/i, '');
  const parts = cleaned.split(':');
  if (parts.length >= 2) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
  return cleaned.slice(0, 5);
};

/**
 * Частичный ввод времени → HH:mm.
 * "12", "12:", "12:--" → 12:00; "12:3" → 12:03; "12:30" → 12:30.
 * Нативный type=time при 12:-- часто отдаёт value="" — для карточки лучше text + эта нормализация.
 */
export const normalizePartialKickoffTime = (value) => {
  const raw = String(value || '').trim();
  if (!raw || raw === '—') return '';
  const soft = raw.replace(/[–—−]/g, '-').replace(/\./g, ':');
  const match = soft.match(/^(\d{1,2})(?::([0-9-]*)?)?(?::\d{0,2})?/);
  if (!match) return kickoffClock(raw);
  const hour = parseInt(match[1], 10);
  if (!Number.isFinite(hour) || hour < 0 || hour > 23) return '';
  const mmPart = match[2];
  if (mmPart == null || mmPart === '' || /^-+$/.test(mmPart)) {
    return `${pad2(hour)}:00`;
  }
  const digits = mmPart.replace(/\D/g, '').slice(0, 2);
  if (!digits) return `${pad2(hour)}:00`;
  const minute = parseInt(digits.padStart(2, '0'), 10);
  if (!Number.isFinite(minute) || minute > 59) return `${pad2(hour)}:00`;
  return `${pad2(hour)}:${pad2(minute)}`;
};

/**
 * Пояс площадки для create/edit/display.
 * Порядок: venue_timezone / IANA на stadium|league|city → город по названию → Europe/Moscow.
 * timezone:"UTC" на карточке — маркер хранения, не пояс площадки.
 */
export const resolveMatchTimezone = (...sources) => {
  for (const source of sources) {
    if (!source) continue;
    if (typeof source === 'string') {
      const asTz = source.trim();
      if (asTz && !isStorageTimezone(asTz) && asTz.includes('/')) return asTz;
      const fromCity = timezoneFromCityName(asTz);
      if (fromCity) return fromCity;
      continue;
    }
    for (const candidate of explicitTimezoneCandidates(source)) {
      const tz = String(candidate || '').trim();
      if (tz && !isStorageTimezone(tz)) return tz;
    }
  }
  for (const source of sources) {
    if (!source || typeof source === 'string') continue;
    for (const cityName of cityNameCandidates(source)) {
      const fromCity = timezoneFromCityName(cityName);
      if (fromCity) return fromCity;
    }
  }
  return DEFAULT_MATCH_TZ;
};

const splitIsoDateTime = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return { date: '', time: '' };
  const match = raw.match(/^(\d{4}-\d{2}-\d{2})(?:[T\s](\d{2}:\d{2}))/);
  if (match) return { date: match[1], time: match[2] };
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw.slice(0, 10))) return { date: raw.slice(0, 10), time: '' };
  return { date: '', time: '' };
};

/** Разобрать сырые date/time с сервера (UTC naive или ISO). */
export const parseUtcKickoffFields = (item = {}) => {
  // После normalize* date/time — стена площадки; исходный UTC лежит в *_utc.
  if (item.date_utc != null || item.time_utc != null) {
    const date = item.date_utc == null || item.date_utc === ''
      ? ''
      : String(item.date_utc).slice(0, 10);
    const time = kickoffClock(item.time_utc)
      || kickoffClock(item.time ?? item.kickoff_time ?? item.match_time);
    return { date, time };
  }
  let date = '';
  let time = kickoffClock(item.time ?? item.kickoff_time ?? item.match_time);
  if (item.no_date || item.date == null || item.date === '') {
    return { date: '', time };
  }
  const fromDate = splitIsoDateTime(item.date);
  date = fromDate.date;
  if (!time && fromDate.time) time = fromDate.time;
  if (!time) {
    const fromKickoff = splitIsoDateTime(item.kickoff || item.datetime || item.start);
    if (!date) date = fromKickoff.date;
    if (fromKickoff.time) time = fromKickoff.time;
  }
  return { date, time };
};

const tzParts = (instant, timeZone) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timeZone || DEFAULT_MATCH_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(instant);
  const get = (type) => parts.find((item) => item.type === type)?.value || '';
  return {
    year: Number(get('year')),
    month: Number(get('month')),
    day: Number(get('day')),
    hour: Number(get('hour')),
    minute: Number(get('minute')),
    second: Number(get('second')),
  };
};

/** UTC date+time (naive) → стенные date/time в IANA-поясе. */
export const utcKickoffToWall = (isoDate, time, timeZone = DEFAULT_MATCH_TZ) => {
  const day = String(isoDate || '').slice(0, 10);
  const clock = kickoffClock(time);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || !clock) return null;
  const [hour, minute] = clock.split(':').map(Number);
  const instant = new Date(`${day}T${pad2(hour)}:${pad2(minute)}:00.000Z`);
  if (Number.isNaN(instant.getTime())) return null;
  const wall = tzParts(instant, timeZone);
  if (!wall.year || !wall.month || !wall.day || wall.hour == null || wall.minute == null) return null;
  return {
    date: `${wall.year}-${pad2(wall.month)}-${pad2(wall.day)}`,
    time: `${pad2(wall.hour)}:${pad2(wall.minute)}`,
  };
};

/**
 * Стенные date+time в поясе → UTC naive date+time для записи в БД.
 * Итеративно подбираем UTC-момент, который в timeZone даёт нужную стену.
 */
export const wallKickoffToUtc = (isoDate, time, timeZone = DEFAULT_MATCH_TZ) => {
  const day = String(isoDate || '').slice(0, 10);
  const clock = kickoffClock(time);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || !clock) return null;
  const [hour, minute] = clock.split(':').map(Number);
  const y = Number(day.slice(0, 4));
  const mo = Number(day.slice(5, 7));
  const d = Number(day.slice(8, 10));
  const wantAsUtcMs = Date.UTC(y, mo - 1, d, hour, minute, 0);
  let guess = wantAsUtcMs;
  for (let i = 0; i < 4; i += 1) {
    const wall = tzParts(new Date(guess), timeZone);
    const gotAsUtcMs = Date.UTC(wall.year, wall.month - 1, wall.day, wall.hour, wall.minute, wall.second || 0);
    guess += wantAsUtcMs - gotAsUtcMs;
  }
  const result = new Date(guess);
  if (Number.isNaN(result.getTime())) return null;
  return {
    date: result.toISOString().slice(0, 10),
    time: result.toISOString().slice(11, 16),
  };
};

/**
 * Поля date/time для API (setMatch / changeAdminMatch / …).
 * Шлём стенные значения как есть + timezone отдельно — сервер сам пишет UTC.
 * Не конвертировать здесь: иначе при timezone=Europe/Moscow получится двойной сдвиг (−6ч).
 */
export const kickoffFieldsForApi = (date, time, _timeZone = DEFAULT_MATCH_TZ) => {
  const clock = normalizePartialKickoffTime(time) || kickoffClock(time);
  if (!date && !clock) return { date: null, time: null };
  return {
    date: date ? String(date).slice(0, 10) : null,
    time: clock ? `${clock}:00` : null,
  };
};
